import { render, staticRenderFns } from "./PerformanceComingSoonPage.vue?vue&type=template&id=66c14e3f&scoped=true"
import script from "./PerformanceComingSoonPage.vue?vue&type=script&lang=js"
export * from "./PerformanceComingSoonPage.vue?vue&type=script&lang=js"
import style0 from "./PerformanceComingSoonPage.vue?vue&type=style&index=0&id=66c14e3f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c14e3f",
  null
  
)

export default component.exports